export default __webpack_public_path__ + "static/media/028-amulet.6370deef.svg";